import React from "react";
import { useField } from "formik";
import { LinearProgress, Grid, Typography } from "@material-ui/core";
import zxcvbn from "zxcvbn";
import { useTranslation } from "react-i18next";

const PasswordStrengthIndicator: React.FC = () => {
  const [{ value: password }] = useField("password");
  const { t } = useTranslation();

  const { score: passwordScore } = zxcvbn(password.substring(0, 128));
  const passwordScorePercent = (passwordScore / 4) * 100;
  return (
    <>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <Typography
                variant="body2"
                component="span"
                data-testid="passwordStrengthTitle"
              >
                {t("passwordManagement.passwordStrengthTitle")}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="body2"
                component="span"
                data-testid="passwordStrengthScore"
              >
                {`${passwordScore + 1} / 5`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <LinearProgress
            color="secondary"
            style={{ height: 8 }}
            variant="determinate"
            value={passwordScorePercent}
          />
        </Grid>
        <Grid item>
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <Typography
                variant="body2"
                component="span"
                data-testid="passwordStrengthLabelWeak"
              >
                {t("passwordManagement.passwordStrengthWeak")}
              </Typography>
            </Grid>

            <Typography
              variant="body2"
              component="span"
              data-testid="passwordStrengthLabelStrong"
            >
              {t("passwordManagement.passwordStrengthStrong")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PasswordStrengthIndicator;
